// extracted by mini-css-extract-plugin
export default {"contentpage-content-wrapper":"W8LFt4gdiKyMiJnBtWpi","contentpage-content-wrapper--home":"rtmyxVqKjLUB5Va8g7bZ"};